// @flow
import HoursContainer from './HoursContainer';

export default HoursContainer;
